import {
    Box,
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    FormControl,
    FormLabel, Input,
    Modal, ModalClose,
    ModalDialog
} from "@mui/joy";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";

type SensitiveActionConfirmationDialogProps = {
    open?: boolean,
    onClose?: () => void,
    onConfirm?: (password?: string) => void,
    onCancel?: () => void,
    negativeActionLoading?: boolean,
    positiveActionLoading?: boolean,
    label?: string,
    message?: string,
}

const SensitiveActionConfirmationDialog = (props: SensitiveActionConfirmationDialogProps) => {
    const {t} = useTranslation()
    const [password, setPassword] = useState<string>()

    return <Modal open={props.open} onClose={props.onClose}>
        <ModalDialog variant="outlined" role="alertdialog" size={"lg"} sx={{minWidth: "30rem"}}>
            <ModalClose/>
            <DialogTitle sx={{alignItems: "center"}}>
                {props.label}
            </DialogTitle>
            <Divider/>
            <DialogContent>
                {props.message}
                <Box paddingY={2} id={"sensitive-action-form"} component={"form"} onSubmit={(e) => {
                    e.preventDefault()
                    props.onConfirm(password)
                }}>
                    <FormControl required>
                        <Input type={"password"} onChange={e => setPassword(e.target.value)}
                               placeholder={t("currentPasswordFieldPlaceholder")}/>
                    </FormControl>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button form={"sensitive-action-form"} type={"submit"} variant="solid" color="danger"
                        loading={props.negativeActionLoading} disabled={!password}>
                    {t("confirmDialogActionButtonLabel")}
                </Button>
                <Button variant="plain" color="neutral" onClick={props.onCancel} loading={props.positiveActionLoading}
                        disabled={props.negativeActionLoading}>
                    {t("cancelDialogActionButtonLabel")}
                </Button>
            </DialogActions>
        </ModalDialog>
    </Modal>
}


export default SensitiveActionConfirmationDialog